var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"apple-btn",attrs:{"id":"appleid-signin","data-color":"white","data-border":"true","data-type":"sign in"},on:{"click":function($event){return _vm.singIn()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }